import { render, staticRenderFns } from "./dap-wizard-stores.page.vue?vue&type=template&id=9568429a&scoped=true"
import script from "./dap-wizard-stores.page.vue?vue&type=script&lang=ts"
export * from "./dap-wizard-stores.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-wizard-stores.page.vue?vue&type=style&index=0&id=9568429a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9568429a",
  null
  
)

export default component.exports